/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-02 16:49:07
 * @modify date 2021-09-02 16:49:07
 * @desc 交易相关
 */
import { CartController } from './cart';
import { OrdersController } from './orders';
import { ThirdOrdersController } from './thirdOrders';
import { ThirdRefundOrdersController } from './thirdRefundOrders';

import { PointsOrdersController } from './pointsOrders';
import { SECController } from './secOrders';
export class TradingController {
  /** 购物车 */
  CartController = new CartController();
  /** 订单 */
  OrdersController = new OrdersController();
  /** 积分订单 */
  PointsOrdersController = new PointsOrdersController();
  /** 订单 */
  ThirdOrdersController = new ThirdOrdersController();
  /** 订单 */
  ThirdRefundOrdersController = new ThirdRefundOrdersController();
  /** SEC订单 */
  SECController = new SECController();
}
